window.addEventListener('beforeunload', () => {
  // istanbul-ignore
  remove('CLAIMS_FETCHING');
});

function remove(key: string) {
  return window.localStorage.removeItem(`$$${key}$$`);
}

function get(key: string) {
  return window.localStorage.getItem(`$$${key}$$`);
}

function set(key: string, value: string | number) {
  return window.localStorage.setItem(`$$${key}$$`, `${value}`);
}

function waitForCheck() {
  return new Promise((resolve) => {
    (function run(): void {
      if (get(`CLAIMS_FETCHING`)) {
        setTimeout(run, 16);
        return;
      }
      resolve(true);
    })();
  });
}

let retries = 0;

export async function setClaims(): Promise<unknown> {
  const BASE_AUTH_API_URL =
    (document.querySelector('#authOrigin') as HTMLInputElement)?.value ||
    process.env.BASE_AUTH_API_URL;

  // If there is any page where mfe-config form appears
  // after loader script it should be restarted
  if (!BASE_AUTH_API_URL) {
    if (++retries > 30) {
      console.warn('no authOrigin provided');
      return Promise.resolve(true);
    }
    return new Promise((resolve) => {
      setTimeout(resolve, 16);
    }).then(() => setClaims());
  }

  if (get(`LOGIN_STRATEGY`) !== 'jwt') {
    return Promise.resolve(true);
  }
  if (get(`CLAIMS_FETCHING`)) {
    return waitForCheck();
  }
  //
  // This flag will be dropped at /login
  // and /admin/login pages (!)
  //
  if (get('CLAIMS')) {
    return Promise.resolve(true);
  }

  set(`CLAIMS_FETCHING`, 'true');

  return new Promise((resolve) => {
    (async function run() {
      try {
        const claims = await fetch(`${BASE_AUTH_API_URL}/auth/v1/jwt/claims`, {
          credentials: 'include',
          headers: {
            'content-type': 'application/json;charset=UTF-8',
          },
        }).then((r) => {
          if (r.status >= 400) {
            throw new Error('claims error');
          }
          return r.json();
        });

        set('CLAIMS', JSON.stringify(claims));
        resolve(claims);
      } catch (e) {
        set('CLAIMS', `{"error": true}`);
        resolve({ error: true });
      }

      remove('CLAIMS_FETCHING');
    })();
  });
}
